<!--
 * @Description: 查赛道
 * @Author:  单珊珊
 * @Date: 2022-02-14 09:22:57
 * @LastEditTime: 2023-07-14 14:01:53
 * @LastEditors:  
-->
<template>
  <div class="first-container">
    <div class="prompt-content">
      <p>动脉网PC3.0抢先体验：7*24小时情报追踪、结构化认知医疗行业大事、医疗产业资源对接等，<a :href="$store.state.index2_path + '/new'">立即体验</a></p>
    </div>
    <!-- <div class="prompt-content">
      <p>NEW！动脉网全新域名</p>
      <a>https://www.vbdata.cn</a>
      <p>正式启用，原网址仍支持访问</p>
    </div> -->
    <div class="company-filter">
      <DataNavigation></DataNavigation>
      <div class="main-container">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <!--赛道全景图-->
        <div class="track-image">
          <div class="chart-desc">
            <div class="image-content" id="chart"></div>
            <div class="track-desc">
              <div class="theme-title">{{current_chart.name}}</div>
              <div class="theme-desc over-p9">
                <p v-html="current_chart.themeDesc"></p>
              </div>
              <button class="more-theme-info" v-if="current_chart.themeId" @click="goToTrackDetail2(current_chart.id)">查看更多赛道信息</button>
            </div>
          </div>
          <div class="source">
            <i class="iconfont">&#xe65c;</i>
            <p>以上版块根据2023年上半年医疗健康产业投融资数据生成，来源动脉橙产业智库。单位：百万美元。</p>
          </div>
        </div>
        <!-- 热词解读 -->
        <div class="hot-topic">
          <img class="hot-logo" src="~pic/reci.png" />
          <a class="hot-words" v-for="item,index in hot_key_list.slice(0,10)" :key="index" :href="item.url" target="_blank" onclick="_czc.push(['_trackEvent', '看赛道(新)', '热词解读(热词)', '点击量'])"><img src="~pic/reci-hot.png" />{{item.name}}</a>
          <div class="right orange more" @click="goToKeyWords">查看更多</div>
        </div>
        <!-- 赛道动态+推荐赛道 -->
        <div class="track-info common-container">
          <!-- 赛道动态 -->
          <div class="track-dynamic common-left">
            <div class="header">
              <div class="left title-underline">赛道动态</div>
              <div class="right orange more" @click="goToTrackList">查看更多赛道</div>
            </div>
            <div class="content">
              <div class="left-image">
                <a @click="goToAdv(banner1)" onclick="_czc.push(['_trackEvent', '看赛道(新)', '赛道动态(广告位左)', '点击量'])">
                  <img :src="banner1.imgPath | logo_show" class="banner-img">
                </a>
              </div>
              <div class="right-image">
                <div class="top">
                  <a @click="goToAdv(banner2)" onclick="_czc.push(['_trackEvent', '看赛道(新)', '赛道动态(广告位右上)', '点击量'])">
                    <img :src="banner2.imgPath | logo_show" class="banner-img">
                  </a>
                </div>
                <div class="bottom">
                  <a @click="goToAdv(banner3)" onclick="_czc.push(['_trackEvent', '看赛道(新)', '赛道动态(广告位右下)', '点击量'])">
                    <img :src="banner3.imgPath | logo_show" class="banner-img">
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- 推荐赛道 -->
          <div class="reco-track common-right">
            <rcTrack :height="255" pageType="3"></rcTrack>
          </div>
        </div>
        <!-- 最近更新 -->
        <div class="lasted-updated">
          <div class="upper">
            <div class="updated-item" v-for="item, index1 in track_list" :key="index1">
              <div class="item-title orange">
                <div class="item-title__left">
                  <p class="left__upper">赛道动态</p>
                  <p class="left__under under-hover l1-ellipsis" @click="goToTrackDetail(item.key, 2)">{{ item.entity_tag }}</p>
                </div>
                <div class="item-title__right">
                  <span @click="goToTrackDetail(item.key, 2)">赛道详情</span>
                </div>
              </div>
              <div class="list-wrap noselect" oncontextmenu="return false" onselectstart="return false">
                <div class="item-list" v-for="(content, index2) in item.value" :key="index2">
                  <div class="legend">
                    <div class="type">{{ content.contnet_type_name }}</div>
                    <div class="time">{{ parseInt(content.sort_time) | time_moment }}<template v-if="content.content_type == 3">更新</template></div>
                  </div>
                  <a :href="$store.state.index2_path + '/' + content.content_id"
                    v-if="content.content_type == 0 || content.content_type == 1" class="list-title over-p2" target="_blank"
                    @click="goToDetail"
                    style="line-height: 25px;">{{ content.title }}</a>
                  <a :href="$store.state.index_path + '/specialDetail/' + content.uid"
                    v-if="content.content_type == 3" class="list-title over-p2" target="_blank"
                    @click="goToDetail"
                    style="line-height: 25px;">{{ content.title }}</a>
                  <a :href="$store.state.index2_path + '/newsDetail/' + content.uid"
                    v-if="content.content_type == 4" class="list-title over-p2" target="_blank"
                    @click="goToDetail"
                    style="line-height: 25px;">{{ content.title }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 投融资报告+活跃赛道 -->
        <div class="report-track common-container">
          <div class="report-content common-left">
            <div class="header">
              <div class="left title-underline">投融资报告</div>
              <div class="right orange more" @click="goToFinancing">查看更多</div>
            </div>
            <div class="report-list content">
              <div class="report-item" v-for="item, index in report_list" :key="index">
                <div class="left">
                  <div class="collect-icon">
                    <i class="iconfont on" title="取消收藏" v-if="item.isCollect == '1'" @click="cancelCollect('1', item.id, delCollectCb2, index)">&#xe66f;</i>
                    <i class="iconfont" title="收藏" v-else @click="addCollect('1', item.id, addCollectCb2, index)">&#xe66f;</i>
                  </div>
                  <img :src="img_req_url + item.logo_path">
                </div>
                <div class="right">
                  <div class="top">
                    <div class="title over-p2">
                      <a :href="$store.state.static_pdf_url + item.file_path.substr(1)" target="_blank" download onclick="_czc.push(['_trackEvent', '看赛道(新)', '投融资报告(标题)', '点击量'])">
                        {{item.title}}
                      </a>
                    </div>
                    <div class="sub-title over-p1">{{item.summary}}</div>
                  </div>
                  <div class="bottom">
                    <div class="track-topic" v-if="item.entityTags.length > 0">
                      <span class="normal">相关赛道</span>
                      <span class="topic" v-show="index1 < 3" v-for="tag, index1 in item.entityTags" :key="index1" @click="goToTrackDetail(tag.id, 3)">{{tag.name}}</span>
                    </div>
                    <div class="time">
                      <i class="iconfont">&#xe632;</i>{{item.publish_time | timeTrans}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="active-track common-right">
            <activeTrack :num="9" pageType="3"></activeTrack>
          </div>
        </div>
        <!-- 机构青睐赛道+活跃机构 -->
        <div class="org-track common-container">
          <div class="org-likes common-left">
            <div class="header">
              <div class="left">
                <div class="title-underline">机构青睐赛道</div>
                <img class="days" :src="$store.state.static_img_url+'pic/vcbeat/30days.png'">
              </div>
              <div class="right orange more" @click="toOrgLikes">查看更多</div>
            </div>
            <div class="org-likes-container content">
              <div class="org-likes-item" v-for="item,index in org_track_list" :key="index">
                <div class="header">
                  <div class="title">
                    <p class="common-title-p orange l1-ellipsis" @click="goToTrackDetail(item.id, 4)">{{item.name}}</p>
                    <div @click="goToTrackDetail(item.id, 4)">赛道详情</div>
                  </div>
                  <div class="event">
                    <span class="name">投融资事件：<span class="number orange">{{item.eventCount}}&nbsp;</span>笔</span>
                    <span class="name">IPO：<span class="number orange">{{item.ipoCount}}&nbsp;</span>笔</span>
                  </div>
                </div>
                <div class="content-wrap">
                  <div class="item-wrap">
                    <p>代表项目</p>
                    <div class="item" v-for="comp,index1 in item.comp" :key="index1">
                      <div class="image">
                        <img :src="img_req_url + comp.logoPath" />
                      </div>
                      <div class="info">
                        <div class="org-name l1-ellipsis" @click="toEntity(comp.type, comp.uid, 1)">{{comp.shortName}}<span class="round">{{comp.roundName}}</span></div>
                        <a :href="$store.state.index_path + '/companyDetail/' + comp.uid"></a>
                        <div class="org-desc l1-ellipsis">{{comp.description}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="item-wrap">
                    <p>代表机构</p>
                    <div class="item" v-for="org,index2 in item.org" :key="index2">
                      <div class="image">
                        <img :src="img_req_url + org.logoPath" />
                      </div>
                      <div class="info">
                        <div class="org-name l1-ellipsis" @click="toEntity(org.type, org.uid, 1)">{{org.shortName}}</div>
                        <a :href="$store.state.index_path + '/orgDetail/' + org.uid"></a>
                        <div class="org-desc l1-ellipsis">{{org.description}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="active-org common-right">
            <activeAgency></activeAgency>
          </div>
        </div>
        <!-- ipo进行时+招股书列表 -->
        <div class="ipo-prospectus common-container">
          <div class="ipo-wrap common-left">
            <div class="header">
              <div class="left title-underline">IPO进行时</div>
              <div class="right orange more" @click="goToIpo">查看更多</div>
            </div>
            <div class="ipo-list content">
              <div class="ipo-item" v-for="item,index in ipo_list" :key="index">
                <div class="title">
                  <a :href="item.type == 1 ? $store.state.index2_path + '/' + item.id : $store.state.index2_path + '/newsDetail/' + item.uid" target="_blank" class="ipo-title">
                    <!-- <img class="ipo-image" src="~pic/IPO.png"> -->
                    <i v-if="item.type == 1" class="iconfont wenzhang">&#xe6bc;</i>
                    <i v-if="item.type == 0" class="iconfont kuaixun">&#xe6bd;</i>
                    {{item.title}}
                  </a>
                  <div class="time">{{item.eventTime | time_moment}}</div>
                </div>
                <div class="content">
                  <div class="org-info">
                    <div class="org-logo">
                      <img :src="img_req_url + item.entityLogoPath" />
                    </div>
                    <div class="right">
                      <p class="org-name l1-ellipsis" @click="toEntity(item.entityType, item.entityUid, 2)">{{item.entityShortName}}</p>
                      <p class="org-business l1-ellipsis">{{item.entityDescription}}</p>
                    </div>
                  </div>
                  <div class="tracks" v-if="item.entityTags.length > 0">
                    <div class="normal">相关赛道</div>
                    <div>
                      <span class="topic" v-show="index1 < 3" v-for="tag,index1 in item.entityTags" :key="index1" @click="goToTrackDetail(tag.id, 5)">{{tag.name}}</span>
                    </div>
                  </div>
                  <div class="download" v-if="item.prospectus">
                    <i class="iconfont">&#xe644;</i><span @click="goTopProspectus(item.entityUid)">招股书下载</span>
                  </div>
                  <div class="firbden-download" v-else>
                    <i class="iconfont">&#xe644;</i><span>招股书下载</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="prospectus-wrap common-right">
            <prospectus></prospectus>
          </div>
        </div>
        <!-- 专题pro -->
        <div class="topic-pro">
          <div class="header">
            <div class="left title-underline">专题Pro</div>
            <div class="right orange more" @click="goToPro">查看更多</div>
          </div>
          <div class="topic-pro-content">
            <div class="topic-pro-item" v-for="item,index in theme_list" :key="index">
              <div class="collect-icon">
                <i class="iconfont on" title="取消收藏" v-if="item.is_collect == '1'" @click="cancelCollect('2', item.id, delCollectCb1, index)">&#xe66f;</i>
                <i class="iconfont" title="收藏" v-else @click="addCollect('2', item.id, addCollectCb1, index)">&#xe66f;</i>
              </div>
              <div class="topic-image" @click="goToSpecialDetail(item.uid)"><img :src="img_req_url + item.share_logo_path"></div>
              <div class="topic-info">
                <div class="topic-title over-p2" @click="goToSpecialDetail(item.uid)">{{item.title}}</div>
                <a :href="$store.state.index_path + '/specialDetail/' + item.uid"></a>
                <div class="topic-update" v-if="item.latest_content && item.latest_content.length > 0">
                  <span class="time">{{item.update_time | time_standard}}更新</span>
                  <span class="desc">{{item.latest_content[0].title}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataNavigation from '@/components/DataNavigation'
import prospectus from './components/Prospectus'
import activeAgency from '@/components/vcbeat/ActiveAgency.vue'
import activeTrack from '@/components/vcbeat/Activetrack.vue'
import rcTrack from '@/components/vcbeat/RCtrack.vue'
import {
  getMeta,
  themeList,
  getOrgLikeTrack,
  getHotKeys,
  getIponews,
  getBanner,
  getChartData,
  eventReport,
  getTrack,
  recommendThemeList,
  addPuv
} from '@/service.js'
import filter from 'js/filter'
import chartoptions from 'js/chartoptions'
import moment from 'moment'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [collect_mixin],
  components: { prospectus, activeAgency, activeTrack, rcTrack, DataNavigation },
  data() {
    return {
      theme_list: [],
      org_track_list: [],
      round_list: [],
      hot_key_list: [],
      ipo_list: [],
      entity_ntag: [],
      chart: '',
      option: '',
      loading: true,
      chart_data: '',
      banner_list: [],
      report_list: [],
      track_list: [],
      content_type: [
        {
          id: 0,
          name: '文章',
        },
        {
          id: 1,
          name: '视频',
        },
        {
          id: 3,
          name: '专题Pro',
        },
        {
          id: 4,
          name: '快讯',
        },
      ],
      current_chart: {},
      current_year: '',
      keywords_url: '',
      banner1: {},
      banner2: {},
      banner3: {},
    }
  },
  created() {
    this.current_year = moment().locale('zh-cn').format('YYYY')
  },
  beforeMount() {
    Promise.all([
      new Promise((resolve) => {
        this.getMeta(resolve)
      }),
      new Promise((resolve) => {
        this.getOrgLikeTrack(resolve)
      }),
      new Promise((resolve) => {
        this.getThemeList(resolve)
      }),
      new Promise((resolve) => {
        this.getHotKeys(resolve)
      }),
      new Promise((resolve) => {
        this.getBanner(resolve)
      }),
      new Promise((resolve) => {
        this.getChartData(resolve)
      }),
    ]).then((res) => {
      this.loading = false
    })
  },
  mounted() {
    this.chart = echarts.init(document.getElementById('chart'))
  },
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    },
  },
  methods: {
    //广告位跳转-统计
    goToAdv(banner) {
      window.open(banner.link, '_blank')
      this.addPuv(banner.uid)
    },
    addCollectCb1(index) {
      this.theme_list[index].is_collect = '1'
    },
    delCollectCb1(index) {
      this.theme_list[index].is_collect = '0'
    },
    addCollectCb2(index) {
      this.report_list[index].isCollect = '1'
    },
    delCollectCb2(index) {
      this.report_list[index].isCollect = '0'
    },
    async addPuv(uid) {
      let res = await addPuv({
        url: "https://www.vbdata.cn/advClick?uid="+uid,
      })
    },
    async getMeta(resolve) {
      let res = await getMeta({ name: ['entity_ntag'] }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      resolve(res)
      if (res.status == 'success') {
        this.entity_ntag = res.meta.entity_ntag
        this.getIponews()
        this.getReportList()
        this.getTrack()
      }
    },
    //专题Pro
    async getThemeList(resolve) {
      let res1 = await themeList(
        {
          keyword: '',
          page: 1,
          theme_type_id: '',
          user_key: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      resolve({
        res1: res1,
        res2: res2,
      })
      let res2 = await recommendThemeList(
        {
          latest_size: '1',
          position_id: '2',
          size: '3',
          user_key: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res1.status == 'success' && res2.status == 'success') {
        this.theme_list = [...res2.res, ...res1.res.slice(0, 7)]
      }
    },
    //机构青睐列表
    async getOrgLikeTrack(resolve) {
      let res = await getOrgLikeTrack({ size: 3 }, (error) => {
        this.$Message.error('请求错误！')
      })
      resolve(res)
      if (res.code == 0) {
        this.round_list = this.$store.state.round
        this.org_track_list = res.data
        this.org_track_list.map((item) => {
          item.comp.map((comp) => {
            this.$set(comp, 'roundName', filter.dealNeed(comp.roundId, this.round_list))
          })
        })
      }
    },
    //热词解读
    async getHotKeys(resolve) {
      let res = await getHotKeys({ position_id: 20 }, (error) => {
        this.$Message.error('请求错误！')
      })
      resolve(res)
      if (res.code == 0) {
        if (res.data.length > 10) {
          let array = []
          while (array.length < 10) {
            let num = Math.floor(Math.random() * res.data.length)
            if (array.indexOf(num) < 0) {
              array.push(num)
              this.hot_key_list.push(res.data[num])
            }
          }
        } else {
          this.hot_key_list = res.data
        }
      }
    },
    //ipo进行时
    async getIponews() {
      let res = await getIponews({ page: 1 }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.ipo_list = res.data.slice(0, 4)
        this.ipo_list.map((item) => {
          let ids = String(item.entityApplayerTagStr).split(',')
          let entityTags = []
          ids.map((id) => {
            entityTags.push({
              id: id,
              name: filter.dealNeed(id, this.entity_ntag),
            })
          })
          this.$set(item, 'entityTags', entityTags)
        })
      }
    },
    // 广告位
    async getBanner(resolve) {
      // this.banner_loading = true
      let res = await getBanner(
        {
          position_id: ['53', '54', '55'],
        },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      resolve(res)
      if (res.code == 0) {
        res.data.forEach((item) => {
          if (item.posId == '53') {
            this.banner1 = item
          } else if (item.posId == '54') {
            this.banner2 = item
            console.log(this.banner2);
          } else if (item.posId == '55') {
            this.banner3 = item
          }
        })
        // this.banner_loading = false
      } else {
        this.$message.error(res.msg)
      }
    },
    //赛道全景图
    async getChartData(resolve) {
      let res = await getChartData((error) => {
        this.$Message.error('请求错误！')
      })
      resolve(res)
      if (res.code == 0) {
        this.chart_data = res.data
        this.current_chart = res.data[0].children[0].children[0]
        this.getChart()
      }
    },
    //获取投融资报告
    async getReportList() {
      let res = await eventReport(
        {
          user_key: this.$store.state.user_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.report_list = res.res.slice(0, 3)
        this.report_list.map((item) => {
          let entityTags = []
          item.tags.map((id) => {
            entityTags.push({
              id: id,
              name: filter.dealNeed(id, this.entity_ntag),
            })
          })
          this.$set(item, 'entityTags', entityTags)
        })
      } else {
        //
      }
    },
    //获取赛道动态
    async getTrack() {
      let res = await getTrack((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.track_list = res.data
        this.track_list.map((item) => {
          this.$set(item, 'entity_tag', filter.dealNeed(item.key, this.entity_ntag))
          item.value.map((o) => {
            this.$set(o, 'contnet_type_name', filter.dealNeed(o.content_type, this.content_type))
          })
        })
      } else {
        this.$Message.error(res.msg)
      }
    },
    getChart() {
      let color = ['#0039A3', '#214F68', '#0E614E', '#60574E', '#893223']
      let color2 = ['#466BB0', '#50798F', '#14886E', '#ADA196', '#CB7F72']
      this.chart_data.map((item, index) => {
        let i = index % 5
        item.itemStyle = {
          borderColor: color[i],
        }
        item.children.map((item2, index2) => {
          item2.itemStyle = {
            borderColor: color2[i],
            color: color2[i],
          }
          item2.children.map((item3) => {
            item3.itemStyle = {
              color: color2[i],
              colorAlpha: 0.7 - (index2 % 4) * 0.2,
            }
          })
        })
      })

      // console.log('chart_data', this.chart_data);
      this.opiton = chartoptions.tree_map(this.chart_data)
      this.$nextTick(() => {
        this.chart.setOption(this.opiton, true)
        this.chart.on('click', (params) => {
          // 点击树状图
          console.log('点击全景图', params.data)
          this.current_chart = params.data
          _czc.push(['_trackEvent', '看赛道(新)', '矩形树图(赛道块)', '点击量'])
        })
      })
    },
    //跳转至专题Pro
    goToPro() {
      const { href } = this.$router.resolve({ name: 'SpecialList' })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '专题pro(查看更多)', '点击量'])
    },
    //跳转至公司详情-招股书下载
    goTopProspectus(id) {
      const { href } = this.$router.resolve({
        name: 'CompanyDetail',
        params: { uid: id },
        query: { fromPath: 'track' },
      })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', 'IPO进行时(招股书下载)', '点击量'])
    },
    //跳转至公司或机构详情
    toEntity(type, id, where) {
      if (type == 0) {
        const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: id } })
        window.open(href, '_blank')
        switch (where) {
          case 1:
            _czc.push(['_trackEvent', '看赛道(新)', '机构青睐赛道(公司)', '点击量'])
            break
          case 2:
            _czc.push(['_trackEvent', '看赛道(新)', 'IPO进行时(公司)', '点击量'])
            break
        }
      } else if (type == 1) {
        const { href } = this.$router.resolve({ name: 'OrgDetail', params: { uid: id } })
        window.open(href, '_blank')
        switch (where) {
          case 1:
            _czc.push(['_trackEvent', '看赛道(新)', '机构青睐赛道(机构))', '点击量'])
            break
          case 2:
            _czc.push(['_trackEvent', '看赛道(新)', 'IPO进行时(机构)', '点击量'])
            break
        }
      }
    },
    //跳转至机构青睐赛道
    toOrgLikes() {
      const { href } = this.$router.resolve({ name: 'orgLikesTrack' })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '机构青睐赛道(查看更多)', '点击量'])
    },
    //跳转至赛道详情页
    goTrackDetail(id) {},
    //跳转至融资报告专题页
    goToFinancing() {
      const { href } = this.$router.resolve({
        name: 'FinancingIndex',
        query: { fromPath: 'track' },
      })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '投融资报告(查看更多)', '点击量'])
    },
    //热词解读跳转
    goToKeyWords() {
      const { href } = this.$router.resolve({ name: 'SearchList', query: { keyword: '热词解读' } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '热词解读(查看更多)', '点击量'])
    },
    //跳转至赛道动态
    goToTrackList(item) {
      const { href } = this.$router.resolve({ name: 'trackList', query: { id: item.key } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '赛道动态(查看更多赛道)', '点击量'])
    },
    //跳转至赛道详情
    goToTrackDetail(id, type) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: id } })
      window.open(href, '_blank')
      switch (type) {
        case 1:
          _czc.push(['_trackEvent', '看赛道(新)', '矩形树图(简介查看更多赛道信息)', '点击量'])
          break
        case 2:
          _czc.push(['_trackEvent', '看赛道(新)', '赛道动态(赛道标签)', '点击量'])
          break
        case 3:
          _czc.push(['_trackEvent', '看赛道(新)', '投融资报告(赛道标签)', '点击量'])
          break
        case 4:
          _czc.push(['_trackEvent', '看赛道(新)', '机构青睐赛道(赛道标签)', '点击量'])
          break
        case 5:
          _czc.push(['_trackEvent', '看赛道(新)', 'IPO进行时(赛道)', '点击量'])
          break
      }
    },
    goToTrackDetail2(id) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { track: id } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '矩形树图(简介查看更多赛道信息)', '点击量'])
    },
    //跳转至ipo列表
    goToIpo() {
      const { href } = this.$router.resolve({ name: 'ipoList' })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', 'IPO进行时(查看更多)', '点击量'])
    },
    //跳转至文章、视频。快讯、专题详情
    goToDetail(item) {
      // switch (item.content_type) {
      //   case 0:
      //     const temp_href = this.$store.state.index2_path + '/' + item.content_id
      //     window.open(temp_href, '_blank')
      //     break
      //   case 1:
      //     const temp_href1 = this.$store.state.index2_path + '/' + item.content_id
      //     window.open(temp_href1, '_blank')
      //     break
      //   case 3:
      //     const { href } = this.$router.resolve({
      //       name: 'SpecialDetail',
      //       params: { uid: item.uid },
      //     })
      //     window.open(href, '_blank')
      //     break
      //   case 4:
      //     const href2 = this.$store.state.index2_path + '/newsDetail/' + item.uid
      //     window.open(href2, '_blank')
      //     break
      // }
      _czc.push(['_trackEvent', '看赛道(新)', '赛道动态(信息流标题)', '点击量'])
    },
    //跳转至专题Pro详情
    goToSpecialDetail(uid) {
      const { href } = this.$router.resolve({ name: 'SpecialDetail', params: { uid: uid } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '专题pro(图片/标题)', '点击量'])
    },
    //跳转至ipo快讯、文章详情
    goToIpoDetail(item) {
      switch (item.type) {
        case 1:
          const temp_href = this.$store.state.index2_path + '/' + item.id
          window.open(temp_href, '_blank')
          break
        case 0:
          const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
          window.open(href, '_blank')
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
@import '~styles/common_track.stylus'
@import '~styles/common_vcbeat.stylus'
.noselect
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select none
.banner-img
  cursor pointer
  transition all 0.5s
  -webkit-transition all 0.5s
  &:hover
    transform scale(1.06)
    transition all 0.6s ease 0s
.first-container
  background #fff
  display flex
  flex-direction column
.prompt-content
  width 100%
  height 28px
  background #FFECDC
  display flex
  justify-content center
  align-items center
  position fixed
  top 64px
  z-index 100
  p
    font-size 12px
    color #FF8824
    a
      color #3652FF
      cursor pointer
.company-filter
  background #fff
  display flex
  justify-content center
  position relative
  padding-top 28px
.main-container
  width 1090px
  margin-left 20px
  padding-top 20px
  position relative
  >>> .track-info
    .common-left
      flex 0 0 750px
    .common-right
      flex 0 0 320px
      margin-left 20px
  .track-image
    width 100%
    // display flex
    height 430px
    box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
    .chart-desc
      width 100%
      display flex
      .image-content
        flex 0 0 870px
      .track-desc
        flex 0 0 220px
        height 392px
        // border 1px solid
        padding 0 20px
        display flex
        flex-direction column
        justify-content center
        align-items center
        .theme-title
          font-size 20px
          font-family PingFang SC
          font-weight bold
          color #FF8824
          margin-bottom 33px
        .theme-desc
          line-height 22px
        .more-theme-info
          margin-top 54px
          width 100%
          height 30px
          background #FF8824
          border-radius 15px
          border none
          font-size 12px
          font-family PingFang SC
          font-weight 400
          color #FFFFFF
          cursor pointer
          transition all 0.5s
          -webkit-transition all 0.5s
          &:hover
            background #FF6600
            border 1px solid #FF6600
    .source
      padding-left 10px
      height 38px
      display flex
      align-items center
      p
        margin-left 8px
        font-size 13px
        font-family PingFang SC
        font-weight 500
        color #999999
      .iconfont
        font-size 16px
        color #EEEEEE
  // 热词解读
  .hot-topic
    margin-top 30px
    display flex
    flex-wrap wrap
    margin-bottom -10px
    .hot-logo
      height 16px
      margin-top 6px
    .hot-words
      height 28px
      line-height 28px
      background #FFFFFF
      box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
      border-radius 14px
      padding 0 10px
      font-size 13px
      font-family PingFang SC
      font-weight 500
      color #6888F8
      margin-right 10px
      cursor pointer
      -webkit-transition all 0.5s
      transition all 0.5s
      white-space nowrap
      margin-bottom 10px
      &:hover
        color #ff8824
      img
        width 12px
        margin-right 10px
    .right
      margin-left 10px
      white-space nowrap
      line-height 28px
  // 赛道动态&推荐赛道
  .track-info
    margin-bottom 5px
    .track-dynamic
      .content
        display flex
        // justify-content space-between
        .left-image
          flex 0 0 500px
          height 255px
          margin-right 10px
          overflow hidden
        img
          width 100%
          height 100%
        .right-image
          display flex
          flex-direction column
          justify-content space-between
          height 255px
          flex 0 0 240px
          div
            width 240px
            height 122px
            overflow hidden
            img
              width 100%
              height 100%
  // 投融资报告&活跃赛道
  .report-track
    .report-content
      .report-list
        .report-item
          display flex
          -webkit-transition all 0.5s
          transition all 0.5s
          &:not(:first-child)
            margin-top 17px
          &:hover
            box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
          .left
            width 242px
            height 150px
            overflow hidden
            position relative
            img
              width 100%
              height 100%
              cursor pointer
              &:hover
                transform scale(1.06)
                transition all 0.6s ease 0s
          .right
            width 526px
            display flex
            flex-direction column
            justify-content space-between
            padding 8px 20px 8px 16px
            .title
              a
                font-size 18px
                font-family PingFang SC
                font-weight 500
                color #333333
                line-height 24px
                text-align justify
                cursor pointer
                transition all 0.5s
                -webkit--transition all 0.5s
                &:hover
                  color #FF8824
            .sub-title
              font-size 13px
              font-family PingFang SC
              font-weight 500
              color #666666
              line-height 20px
              margin-top 13px
            .bottom
              display flex
              .normal
                margin-right 10px
              .time
                font-size 12px
                font-family PingFang SC
                font-weight 500
                color #999999
                line-height 18px
                margin-left auto
                .iconfont
                  font-size 12px
                  margin-right 7px
  // 专题pro
  .topic-pro
    margin-top 30px
    margin-bottom 20px
    .topic-pro-content
      display flex
      flex-wrap wrap
      margin-top 20px
      margin-left -16px
      .topic-pro-item
        width 204px
        height 224px
        overflow hidden
        cursor pointer
        margin-left 16px
        position relative
        &:nth-child(n+6)
          margin-top 16px
        &:hover
          .topic-info
            transition all 0.5s
            -webkit-transition all 0.5s
            transform translateY(-28px)
            .topic-update
              -webkit-line-clamp 2
              line-clamp 2
          .topic-image
            transition all 0.5s
            -webkit-transition all 0.5s
            transform translateY(-28px)
        .topic-image
          height 128px
          img
            height 100%
            width 100%
        .topic-info
          height 124px
          background #F8F9FA
          padding 15px 15px 0
          display flex
          flex-direction column
          justify-content flex-start
          .topic-title
            font-size 14px
            font-family PingFang SC
            font-weight 500
            color #333333
            line-height 20px
            height 40px
            cursor pointer
            transition all 0.5s
            -webkit-transition all 0.5s
            &:hover
              color #FF8824
          .topic-update
            margin-top 12px
            font-size 12px
            font-family PingFang SC
            font-weight 500
            text-overflow -o-ellipsis-lastline
            overflow hidden
            text-overflow ellipsis
            display -webkit-box
            -webkit-line-clamp 1
            line-clamp 1
            -webkit-box-orient vertical
            line-height 20px
            div
              display inline-block
            .time
              color #FA7A50
              white-space nowrap
              margin-right 5px
            .desc
              color #999999
              margin-left 5px
  .tool-tip
    .tool-head
      color #fff
      font-size 12px
      line-height 1
    .tip-item
      display flex
      font-size 12px
      color #fff
      align-items center
      line-height 1
      margin-top 10px
      .spa1
        color #CCCCCC
  >>>.ivu-spin-fix
    .ivu-spin-main
      top 300px
  .collect-icon
    position absolute
    z-index 4
    right 10px
    top 10px
    width 16px
    height 16px
    background #F3F3F3
    border-radius 4px
    display flex
    justify-content center
    align-items center
    margin 2px 0 0 12px
    cursor pointer
    .iconfont
      font-size 12px
      color #CCCCCC
      &.on
        color #FF8824
</style>
